import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  root: { display: "flex", flexWrap: "wrap", marginTop: "45px" }
}));

export default useStyles;
